import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { theme } from 'aimo-ui';
import MenuItem from 'components/common/MenuItem';
import { Container } from 'components/park/styles/styles';
import HslContext from 'context/HslContext';
import React, { useContext } from 'react';
import { ScrollView } from 'react-native-gesture-handler';
import { StyledImage, StyledWrapper } from 'styles/ContainerStyles';
import { HslParkingStackParamList, ServicesNavProps } from 'types/navigation';

const HslZoneSelectModalContent = () => {
  const { availableZones, selections, setSelections, setCurrentScreen } =
    useContext(HslContext);
  const { navigate } = useNavigation<ServicesNavProps>();
  const { goBack, canGoBack } =
    useNavigation<StackNavigationProp<HslParkingStackParamList>>();

  const handleBack = () => {
    if (canGoBack()) {
      goBack();
    } else {
      navigate('hslNavigator', { screen: 'hslTicket' });
    }
  };
  const onSelection = (zone: string) => {
    setSelections({ ...selections, selectedZone: zone });
    handleBack();
  };

  return (
    <Container testID="hsl-select-zone-container" mr={20} ml={20} mb={50}>
      <StyledWrapper mb={20} center>
        <StyledImage
          testID="hsl-zone-map"
          width={350}
          height={291}
          source={require('../../assets/images/HSLMap.png')}
        />
      </StyledWrapper>
      <ScrollView>
        {availableZones.map((zone) => (
          <StyledWrapper key={`hsl-zone-${zone}`} mb={5}>
            <MenuItem
              noBorder
              testID={`hsl-zone-${zone}`}
              onPress={() => onSelection(zone)}
              menuLabel={zone}
              background={theme.colors.gray50}
            />
          </StyledWrapper>
        ))}
      </ScrollView>
    </Container>
  );
};

export default HslZoneSelectModalContent;
